import type { KnowledgeArticleTranslations } from './articles.types';

export const KNOWLEDGE_BASE_ARTICLES_AR: KnowledgeArticleTranslations = {
  pickup: {
    title: 'طلبات الاستلام',
    summary: "إنشاء طلبات الاستلام وتتبعها وإدارتها.",
    content:
      'تُستخدم طلبات الاستلام لجدولة جمع النفايات من مواقعك. من القائمة الجانبية، افتح «طلبات الاستلام» لإنشاء طلب جديد أو عرض القائمة أو متابعة حالة الطلبات.\n\nاختر أحد الخيارات أدناه لمعرفة الخطوات خطوة بخطوة.',
  },
  'view-pickup-orders-list': {
    title: "عرض قائمة طلبات الاستلام",
    summary: "افتح جدول الطلبات وابحث وتصفّح طلبات الاستلام.",
    content:
      "1. من القائمة الجانبية، افتح «طلبات الاستلام».\n\n2. يعرض الجدول الرئيسي طلبات منظمتك مع المعرّف وموقع التجميع والحالة والتواريخ.\n\n3. استخدم مربع البحث أعلى الجدول للعثور على طلب بالمعرّف أو موقع التجميع.\n\n4. مرّر الجدول واستخدم التصفح في الأسفل لعرض المزيد من الصفوف.\n\nنصيحة: شرائح الحالة وفلاتر التاريخ أعلى الجدول تضيّق النتائج — راجع الأدلة ذات الصلة لهذه الأدوات.",
  },
  'create-pickup-order-outlet': {
    title: 'إنشاء طلب استلام جديد',
    summary: "دليل خطوة بخطوة لجدولة استلام النفايات.",
    content:
      '1. من القائمة الجانبية، افتح «طلبات الاستلام» ثم «إنشاء طلب استلام» (أو انقر على زر + في صفحة طلبات الاستلام).\n\n2. تفاصيل الطلب:\n   • نوع المادة (إلزامي) — تُعبَّأ فئة النفاية ووحدة القياس تلقائياً.\n\n3. الموقع والحاوية:\n   • موقع التجميع (إلزامي)\n   • الحاوية في الموقع المختار\n   • مستوى الامتلاء — ممتلئة بالكامل، ثلاثة أرباع، نصف ممتلئة، أو ربع ممتلئة\n\n4. انقر «حفظ». يظهر الطلب في القائمة بحالة «قيد الانتظار».',
  },
  material: {
    title: 'المواد',
    summary: "إضافة أنواع المواد لطلبات الاستلام وتعديلها وإدارتها.",
    content:
      'اختر من الخيارات أدناه لمعرفة كيفية إضافة أنواع المواد وتعديلها.',
  },
  'add-material-type': {
    title: 'إضافة نوع مادة',
    summary: "تسجيل نوع مادة نفايات لطلبات الاستلام.",
    content:
      '1. من القائمة الجانبية، افتح «إعادة التدوير» ثم «أنواع المواد».\n\n2. انقر «إضافة مادة» (أعلى اليمين).\n\n3. أدخل اسم المادة والفئة ووحدة القياس (مثل: كجم، طن، أكياس).\n\n4. انقر «حفظ». تصبح المادة متاحة عند إنشاء طلبات الاستلام.',
  },
  container: {
    title: 'الحاويات',
    summary: "إضافة الحاويات وإدارتها وتتبعها.",
    content:
      'اختر من الخيارات أدناه لمعرفة كيفية إدارة الحاويات.',
  },
  'add-container': {
    title: 'إضافة حاوية جديدة',
    summary: "تسجيل حاوية نفايات في موقع تجميع.",
    content:
      '1. من القائمة الجانبية، افتح «الحاويات» ثم «قائمة الحاويات».\n\n2. انقر «إضافة حاوية» (أعلى اليمين).\n\n3. أدخل بيانات الحاوية: الاسم، نوع المادة، موقع التجميع، الحالة، وأي حقول إلزامية أخرى.\n\n4. انقر «حفظ». تظهر الحاوية في القائمة ويمكن اختيارها عند إنشاء طلبات الاستلام.',
  },
  'collection-site': {
    title: 'مواقع التجميع',
    summary: "إضافة مواقع تجميع النفايات وتعديلها وإدارتها.",
    content:
      'اختر من الخيارات أدناه لمعرفة كيفية إدارة مواقع التجميع.',
  },
  'add-collection-site': {
    title: 'إضافة موقع تجميع جديد',
    summary: "إنشاء موقع يُجمع منه النفايات.",
    content:
      '1. من القائمة الجانبية، افتح «الحاويات» ثم «مواقع التجميع».\n\n2. انقر «إضافة موقع» (أعلى اليمين).\n\n3. أدخل اسم الموقع والعنوان وأي تفاصيل مطلوبة.\n\n4. انقر «حفظ». يمكنك بعد ذلك ربط الحاويات بالموقع واختياره في نماذج طلبات الاستلام.',
  },

  truck: {
    title: 'الشاحنات',
    summary: "إضافة المركبات وفهم حالات الأسطول وإدارة الشاحنات.",
    content:
      'اختر من الخيارات أدناه لمعرفة كيفية إدارة أسطول المركبات.',
  },
  'add-vehicle': {
    title: 'إضافة مركبة',
    summary: "تسجيل شاحنة أو مركبة أسطول جديدة بكل التفاصيل.",
    content:
      '1. من القائمة الجانبية، افتح «الشاحنات» للوصول إلى «إدارة الأسطول».\n\n2. انقر «إضافة مركبة» (أعلى اليمين).\n\n3. املأ النموذج:\n   • أرقام اللوحة (عربي وإنجليزي)\n   • اسم المركبة (إلزامي)\n   • السعة ووحدة السعة\n   • نوع المركبة والطراز ورقم الهيكل (VIN) والوزن الفارغ واستهلاك الوقود\n   • الحالة — اختر «متاحة» إذا كانت المركبة جاهزة للتعيين\n\n4. انقر «حفظ». تظهر المركبة في جدول الأسطول.',
  },
  driver: {
    title: 'السائقون',
    summary: "تسجيل السائقين وعرض الملفات وإدارة تعيين الشاحنات.",
    content:
      'اختر من الخيارات أدناه لمعرفة كيفية إدارة السائقين.',
  },
  'add-driver': {
    title: 'إضافة سائق',
    summary: "إنشاء حساب سائق مع الرخصة والبيانات الشخصية.",
    content:
      '1. من القائمة الجانبية، افتح «السائقون».\n\n2. انقر «إضافة سائق» (أعلى اليمين).\n\n3. قسم الحساب: البريد الإلكتروني وكلمة المرور وتأكيدها.\n\n4. قسم البيانات الشخصية: الاسم، رقم الهاتف، الجنس، الجنسية، وغيرها.\n\n5. قسم السائق والمركبة: رقم رخصة القيادة، تاريخ انتهائها، ورقم تسجيل المركبة.\n\n6. انقر «حفظ». يظهر السائق في الجدول.',
  },
  'understanding-notifications': {
    title: 'الإشعارات',
    summary: "كيفية تفعيل تنبيهات المنصة وقراءتها وإدارتها.",
    content:
      'تفعيل إشعارات المتصفح:\nعند ظهور طلب الإذن، انقر «سماح» لتلقي تنبيهات الطلبات والمنصة خارج التطبيق.\n\nعرض الإشعارات:\n1. انقر أيقونة الجرس في الشريط العلوي.\n2. تعرض اللوحة الإشعارات غير المقروءة مع العنوان والرسالة والوقت.\n3. انقر على إشعار لتحديده كمقروء.\n4. استخدم «تحديد الكل كمقروء» لإزالة جميع الإشعارات غير المقروءة دفعة واحدة.\n\nملاحظة مهمة:\n• الرقم الظاهر على الجرس يوضح عدد الإشعارات غير المقروءة.',
  },
  'pickup-order-statuses': {
    title: 'حالات طلب الاستلام',
    summary: "معنى كل حالة طلب أثناء تقدمه في العمليات.",
    content:
      'يمكنك مراجعة الحالة الحالية من قائمة «طلبات الاستلام». تُحدَّث الحالة تلقائياً مع تقدم الطلب.\n\n• قيد الانتظار — تم إنشاء الطلب وينتظر المعالجة أو التعيين.\n• قيد النقل — جمع النفايات أو نقلها جارٍ.\n• مكتمل — تم تنفيذ الطلب بنجاح.\n• ملغى — تم إلغاء الطلب ولن يُستكمل.',
  },
  'filter-pickup-orders-by-date': {
    title: 'تصفية الطلبات حسب التاريخ',
    summary: "العثور على الطلبات ضمن نطاق تاريخ محدد.",
    content:
      '1. من القائمة الجانبية، افتح «طلبات الاستلام».\n\n2. انتقل إلى قسم «التصفية حسب التاريخ».\n\n3. حدّد تاريخ البداية وتاريخ النهاية.\n\n4. انقر «تطبيق التواريخ» لتصفية القائمة.\n\n5. انقر «مسح التواريخ» لإزالة التصفية والعودة إلى العرض الافتراضي.',
  },
  'container-fill-level': {
    title: 'مستوى امتلاء الحاوية',
    summary: "كيفية اختيار مستوى الامتلاء المناسب للحاوية.",
    content:
      'عند اختيار حاوية في نموذج «إنشاء طلب استلام»، يصبح تحديد مستوى الامتلاء إلزامياً.\n\nالخيارات المتاحة:\n• ممتلئة بالكامل — الحاوية ممتلئة بالكامل\n• ثلاثة أرباع ممتلئة — تقريباً 75% ممتلئة\n• نصف ممتلئة — تقريباً 50% ممتلئة\n• ربع ممتلئة — تقريباً 25% ممتلئة\n\nاختر المستوى الأقرب للواقع لمساعدة فرق العمليات والسائقين على التخطيط بشكل أفضل.',
  },
  'container-statuses': {
    title: 'حالات الحاوية',
    summary: "معنى كل حالة حاوية ومتى تُستخدم.",
    content:
      'يمكنك تعيين الحالة أو مراجعتها عند إضافة حاوية أو تحريرها من «قائمة الحاويات».\n\n• جاهزة للاستلام — الحاوية جاهزة وجمع النفايات منها متاح.\n• في انتظار الاستلام — الطلب مجدول أو بانتظار التنفيذ.\n• فارغة — لا توجد نفايات للجمع.\n• قيد الصيانة — الحاوية خارج الخدمة مؤقتاً.\n• قيد الإعداد — الحاوية قيد التجهيز.\n• غير نشطة — الحاوية غير مستخدمة حالياً.',
  },
  'print-container-qr': {
    title: 'طباعة رمز QR للحاوية',
    summary: "إنشاء وطباعة ملصق QR للاستخدام الميداني.",
    content:
      '1. افتح «الحاويات» ← «قائمة الحاويات».\n\n2. ابحث عن الحاوية في الجدول.\n\n3. انقر أيقونة QR في صف الحاوية.\n\n4. استخدم نافذة الطباعة لطباعة الملصق.\n\nيُنصح بلصق الملصق على الحاوية في الموقع لتسهيل التعريف والمسح الميداني.',
  },
  'edit-material-type': {
    title: 'تحرير أو حذف نوع مادة',
    summary: "تحديث نوع مادة أو إزالته من إعدادات إعادة التدوير.",
    content:
      '1. افتح «إعادة التدوير» ← «أنواع المواد».\n\n2. للتحرير: انقر أيقونة التحرير، عدّل البيانات، ثم انقر «حفظ».\n\n3. للحذف: انقر أيقونة الحذف، ثم أكّد العملية.\n\nتحذير: لا تحذف نوع مادة مرتبطاً بطلبات استلام نشطة. أنهِ أو حدّث تلك الطلبات أولاً.',
  },
  'edit-or-delete-container': {
    title: 'تحرير أو حذف حاوية',
    summary: "تحديث حاوية أو إزالتها من القائمة.",
    content:
      '1. افتح «الحاويات» ← «قائمة الحاويات».\n\n2. للتحرير: انقر أيقونة التحرير، عدّل التفاصيل، ثم انقر «حفظ».\n\n3. للحذف: انقر أيقونة الحذف، ثم أكّد العملية.\n\nتحذير: قد تكون الحاوية مرتبطة بطلبات استلام. تأكد من ذلك قبل الحذف.',
  },
  'edit-or-delete-collection-site': {
    title: 'تحرير أو حذف موقع تجميع',
    summary: "تحديث موقع تجميع أو إزالته.",
    content:
      '1. افتح «الحاويات» ← «مواقع التجميع».\n\n2. انقر «تحرير» أو «حذف» على بطاقة الموقع.\n\n3. أكّد الحذف إذا طُلب منك ذلك.\n\nتحذير: قد يكون الموقع مرتبطاً بالحاويات وطلبات الاستلام. راجع الارتباطات قبل الحذف.',
  },
  'truck-statuses': {
    title: 'حالات المركبة',
    summary: "معنى كل حالة مركبة أسطول ومتى تُستخدم.",
    content:
      'تظهر حالة كل مركبة في جدول «إدارة الأسطول». يمكنك تحديثها عند الإضافة أو التحرير.\n\n• متاحة — المركبة جاهزة للتعيين لسائق أو رحلة.\n• غير متاحة — المركبة غير قابلة للاستخدام حالياً.\n• قيد النقل — المركبة على الطريق.\n• تحميل / تفريغ — المركبة في موقع التحميل أو التفريغ.\n• قيد الصيانة — المركبة تحت الإصلاح أو الصيانة.\n\nنصيحة: عند توقف المركبة مؤقتاً، يُفضَّل تغيير الحالة إلى «غير متاحة» أو «قيد الصيانة» بدلاً من حذفها.',
  },
  'view-driver-details': {
    title: 'عرض تفاصيل السائق',
    summary: "فتح ملف السائق وبيانات الرخصة والشاحنة المعيَّنة.",
    content:
      '1. من القائمة الجانبية، افتح «السائقون».\n\n2. ابحث عن السائق في الجدول.\n\n3. انقر أيقونة العرض (العين) لفتح صفحة التفاصيل.\n\n4. تعرض النافذة: بيانات الحساب، البيانات الشخصية، معلومات الرخصة، والشاحنة المعيّنة إن وُجدت.\n\n5. للتحرير: انقر «تحرير» داخل النافذة، أو استخدم قائمة الإجراءات في الصف.\n\nإذا كانت الشاحنة «غير معيّنة»، اختر «تعيين إلى شاحنة» من قائمة الإجراءات.',
  },
  'edit-or-delete-vehicle': {
    title: 'تحرير أو حذف مركبة',
    summary: "تحديث بيانات المركبة أو إزالة شاحنة من الأسطول.",
    content:
      'تحرير مركبة:\n1. افتح «الشاحنات» ← «إدارة الأسطول».\n2. انقر أيقونة التحرير في الصف، أو افتح التفاصيل ثم اختر «تحرير».\n3. عدّل الحقول وانقر «حفظ».\n\nحذف مركبة:\n1. انقر أيقونة الحذف في الصف، أو من نافذة التفاصيل.\n2. أكّد الحذف.\n\nتحذير: قد يؤثر الحذف على العمليات الجارية إذا كانت المركبة معيّنة لسائق أو مرتبطة برحلات نشطة.',
  },
  'edit-or-delete-driver': {
    title: 'تحرير السائق وتعيين الشاحنة',
    summary: "تحديث بيانات السائق وإدارة تعيين الشاحنات.",
    content:
      'تحرير بيانات السائق:\n1. افتح «السائقون».\n2. من قائمة الإجراءات في الصف، اختر «تحرير السائق».\n3. عدّل البيانات وانقر «حفظ».\n\nبديل: انقر أيقونة العرض ثم «تحرير» من نافذة التفاصيل.\n\nتعيين شاحنة:\n1. من قائمة الإجراءات، اختر «تعيين إلى شاحنة».\n2. اختر شاحنة متاحة (التي ليس لها سائق معيّن) ثم أكّد.\n\nإلغاء التعيين:\n1. من قائمة الإجراءات، اختر «إلغاء التعيين من الشاحنة» (يظهر فقط عند وجود تعيين).\n2. أكّد العملية.',
  },
};
